import { render, staticRenderFns } from "./CoAdminEventsList.vue?vue&type=template&id=7a0954e4&scoped=true&"
import script from "./CoAdminEventsList.vue?vue&type=script&lang=ts&"
export * from "./CoAdminEventsList.vue?vue&type=script&lang=ts&"
import style0 from "./CoAdminEventsList.vue?vue&type=style&index=0&id=7a0954e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0954e4",
  null
  
)

export default component.exports